// extracted by mini-css-extract-plugin
export var deliveryRow = "_sz-a";
export var fixedHeight = "_sz-4";
export var freightLogo = "_sz-9";
export var fullWidth = "_sz-3";
export var priceColumn = "_sz-5";
export var radioSelected = "_sz-7";
export var radioUnselected = "_sz-6";
export var selectedOption = "_sz-2";
export var selectedOptionContainer = "_sz-1";
export var selection = "_sz-0";
export var tallSkeletonText = "_sz-8";